var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('FormBuilder',{attrs:{"label":"Kategori Induk","create":"","fields":_vm.fields,"loading-submit":_vm.$store.state.parentCategory.loadingSubmit},on:{"submit":_vm.submitData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }